import { render, staticRenderFns } from "./More.vue?vue&type=template&id=6e6fe1dc&scoped=true"
import script from "./More.vue?vue&type=script&lang=js"
export * from "./More.vue?vue&type=script&lang=js"
import style0 from "./More.vue?vue&type=style&index=0&id=6e6fe1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6fe1dc",
  null
  
)

export default component.exports